import {
  CollapsibleContent,
  CollapsibleTrigger,
} from '@synoptic/ui-kit/collapsible/collapsible.js';
import { Collapsible } from '@synoptic/ui-kit/collapsible/collapsible.js';
import { MinusIcon } from '@synoptic/ui-kit/icons/react/minus.js';
import { PlusIcon } from '@synoptic/ui-kit/icons/react/plus.js';
import { inputOptional } from '@synoptic/ui-kit/input/input.css.js';
import clsx from 'clsx';
import { PropsWithChildren, ReactNode } from 'react';
import { useState } from 'react';
import {
  collapsibleLabel,
  collapsibleLabelIcon,
  descriptionVariants,
  titleVariants,
} from './collapsible-label.css';
interface CollapsibleLabelProps {
  title?: string;
  description?: string;
  /** Preview of the section's current value, shown while collapsed */
  summary?: ReactNode;
  showArrow?: boolean;
  size?: 'sm' | 'md';
  testId?: string;
}

export const CollapsibleLabel = ({
  children,
  title,
  description,
  summary,
  showArrow = true,
  size = 'md',
  testId,
}: PropsWithChildren<CollapsibleLabelProps>) => {
  const [open, setOpen] = useState(false);
  return (
    <Collapsible data-testid={testId} open={open} onOpenChange={setOpen}>
      <CollapsibleTrigger asChild>
        <div className={collapsibleLabel}>
          {title && <p className={titleVariants[size]}>{title}</p>}
          {description && (
            <p className={clsx(inputOptional, descriptionVariants[size])}>
              ({description})
            </p>
          )}
          {!open && summary}
          {showArrow &&
            (open ? (
              <MinusIcon
                width={20}
                height={20}
                className={collapsibleLabelIcon}
              />
            ) : (
              <PlusIcon
                width={20}
                height={20}
                className={collapsibleLabelIcon}
              />
            ))}
        </div>
      </CollapsibleTrigger>
      <CollapsibleContent>{children}</CollapsibleContent>
    </Collapsible>
  );
};
